import { Action } from 'redux';

import { ClearMetricsDataCache } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export function clearMetricsDataCache(): Action {
  return {
    type: ClearMetricsDataCache,
  };
}

export const isClearMetricsDataCache = isActionFactory<Action>(ClearMetricsDataCache);
